export const RenderMode = {
    Always: 0,
    OnChange: 1,
    Never: 2
};
